import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { Family } from 'src/app/core/_models/family';
import { FamilyService } from 'src/app/core/_services/family.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { DialogOverviewComponent } from '../dialog-overview/dialog-overview.component';

@Component({
  selector: 'app-dialog-family',
  templateUrl: './dialog-family.component.html',
  styleUrls: ['./dialog-family.component.scss']
})
export class DialogFamilyComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogFamilyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private familyService: FamilyService,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickDelete(family: Family) {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_family') }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.familyService.deleteFamily(family.familyId);
          this.dialogRef.close();
          this.snackbarService.open(SnackbarTypes.delete);
        } catch (error) {
          this.snackbarService.open(SnackbarTypes.error);
        }
      }
    });
  }
}
